/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./dialogDeleteTenant.vue?vue&type=template&id=96275ece&scoped=true&"
import script from "./dialogDeleteTenant.vue?vue&type=script&lang=js&"
export * from "./dialogDeleteTenant.vue?vue&type=script&lang=js&"
import style0 from "./dialogDeleteTenant.vue?vue&type=style&index=0&id=96275ece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96275ece",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VTextField,VTreeview})
